export default __webpack_public_path__ + "static/media/logo-white.ad9224a3.png";